import { AppSettings } from '../configs';
import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";

const ExtendConsiderationPeriodService={};

ExtendConsiderationPeriodService.searchPoContractNo = (poContractNo)=>{
    return new Promise((resolve, reject) => {
        axios({
          headers: { ...authHeader(), 'Pragma': 'no-cache' },
          method: "get",
          url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/SearchPoContractNo`,
          params: {
            poContractNo: poContractNo
          }
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
}

ExtendConsiderationPeriodService.getNewAttachments = (transaction_no)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/GetNewAttachments`,
        params: {
          transaction_no : transaction_no
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ExtendConsiderationPeriodService.saveExtendConsiderationPeriod = (obj)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "put",
        url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/SaveExtendConsiderationPeriod`,
        data: {
          ...obj
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ExtendConsiderationPeriodService.submitExtendConsiderationPeriod = (obj)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "put",
        url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/SubmitExtendConsiderationPeriod`,
        data: {
          ...obj
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ExtendConsiderationPeriodService.getExtendConsiderationPeriod = (transactionNo)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/GetExtendConsiderationPeriod`,
        params: {
          transaction_no: transactionNo
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ExtendConsiderationPeriodService.getExtendConsiderationPeriodAll = ()=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ExtendConsiderationPeriod/GetExtendConsiderationPeriodAll`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ExtendConsiderationPeriodService.getNextDayWithoutWeekEndAndHoliday = (date, day)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetNextDayWithoutWeekEndAndHoliday`,
        params: {
          date: date,
          day: day
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

export default ExtendConsiderationPeriodService;
